export const DATE_RANGE_SHORTCUTS_FULL = [{
    text: "Last 7 Days",
    onClick (picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit("pick", [start, end]);
    }
}, {
    text: "Last 30 Days",
    onClick (picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit("pick", [start, end]);
    }
}, {
    text: "Last 60 Days",
    onClick (picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
        picker.$emit("pick", [start, end]);
    }
}, {
    text: "Last 90 Days",
    onClick (picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        picker.$emit("pick", [start, end]);
    }
}, {
    text: "Last 180 Days",
    onClick (picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
        picker.$emit("pick", [start, end]);
    }
}, {
    text: "Last 365 Days",
    onClick (picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
        picker.$emit("pick", [start, end]);
    }
}];

export default {
    data(){
        return {

        }
    }
}
